import { faComment } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Link } from "@/mk2/components/Link";
import { REPLY_LINK } from "@/mk/autogenerated/translations/ReplyButton.1c71acb1fc4bd0d96ec7ec1a1a1b8f93";

import styles from "./ReplyButton.mscss";

interface OwnProps {
    className?: string;

    onClick: React.MouseEventHandler<HTMLButtonElement>;
    link: string;
    asAnchor: boolean;
}

type Props = OwnProps;

class ReplyButton extends React.PureComponent<Props> {
    public render() {
        const { className, onClick, asAnchor, link } = this.props;
        return asAnchor ? (
            <Link to={link} className={cx(styles.ReplyButton, className)}>
                <FontAwesomeIcon icon={faComment} className={styles.ReplyButton__icon} />
                {REPLY_LINK}
            </Link>
        ) : (
            <button type="button" className={cx(styles.ReplyButton, className)} onClick={onClick}>
                <FontAwesomeIcon icon={faComment} className={styles.ReplyButton__icon} />
                {REPLY_LINK}
            </button>
        );
    }
}

export default ReplyButton;
